export function setCookie(name, value, props) {

  props = props || {};
  props.path = '/';
  let exp = props.expires;
  if (typeof exp == 'number' && exp) {
    const d = new Date();
    d.setTime(d.getTime() + exp * 1000);
    exp = props.expires = d;
  }
  if (exp && exp.toUTCString) {
    props.expires = exp.toUTCString();
  }
  value = encodeURIComponent(value);
  let updatedCookie = name + '=' + value;

  for (const propName in props) {
    updatedCookie += '; ' + propName;
    const propValue = props[propName];
    if (propValue !== true) {
      updatedCookie += '=' + propValue;
    }
  }
  document.cookie = updatedCookie;
}

export function getCookie(name) {
  const matches = document.cookie.match(
    // eslint-disable-next-line
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function deleteAllCookies() {

  document.cookie.split(";").forEach((c, index) => {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  document.cookie='accessToken=; Path=/; Max-Age=-1;';
  document.cookie='accessToken=; Path=/profile; Max-Age=-1;';
  document.cookie='accessToken=; Path=/orders; Max-Age=-1;';
  document.cookie='refreshToken=; Path=/; Max-Age=-1;';
  document.cookie='refreshToken=; Path=/profile; Max-Age=-1;';
  document.cookie='refreshToken=; Path=/orders; Max-Age=-1;';

}
